import React                        from 'react';
import ChatBot                      from 'react-simple-chatbot';
import { ThemeProvider }            from 'styled-components';
import { connect }                  from 'react-redux';
import { withRouter }               from 'react-router';
import PubSub                       from 'pubsub-js';
import { ConnectConstants }         from '../connect/environment';
import { connectFeedbackFetchData } from '../../../actions/connect/feedback';
import { connectRegisterFetchData } from '../../../actions/connect/register';
import logo                         from '../../../images/bsu-dns.png';
import { isLoggedIn }               from '../../../utils/authService';
import FeedbackWidget               from './widget/FeedbackWidget';
import SendFeedback                 from './SendFeedback.js';
 
var apiHost = ConnectConstants.WebApiHost;

// TODO: Currently this feedback only works with the Connect module

var HELP_MSG   = 'Hi! Please leave us any feedback you have about the chat experience. ';

const theme = {
  background: '#f5f8fb',
  // Let the theme take this over - fontFamily: 'Helvetica Neue',
  headerBgColor: '#0033a0',
  headerFontColor: '#fff',
  // headerFontSize: '15px',
  botBubbleColor: '#0033a0',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  //userFontColor: '#4a4a4a',
};

class Feedback extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      userId: '',
      key: false
    };
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }
  
  componentDidMount() {  
    this.token = PubSub.subscribe('feedback.attributes', this.subscriber.bind(this));
  }
  
  subscriber(msg, data) {
    if (msg === "feedback.attributes") {
      var userId = this.state.userId;
      if (data.hasOwnProperty('userId')) {
        userId = data.userId;
      }
      
      var anonymousAuth = this.state.anonymousAuth;
      if (data.hasOwnProperty('anonymousAuth')) {
        anonymousAuth = data.anonymousAuth;
      }
      
      this.setState({
        userId: userId,
        anonymousAuth: anonymousAuth,
        key: Date.now()
      });
    }
  }
  
  handleNewUserMessage = (newMessage, OTPToken) => {
    var msg = {
      Feedback: newMessage,
      Username: this.state.userId,
      Attributes: {
        OTPToken: OTPToken,
        Authentication: this.state.anonymousAuth
      }
    };
    
    this.props.fetchFeedback(apiHost, msg);
  }

  handleNewRegisterMessage = (newMessage) => {
    /*var msg = {
      text: newMessage,
      userId: chatUserId(),
      page: this.props.location.pathname      
    };*/
    
    // TODO: Maybe implement this in the future - this.props.fetchRegister(apiHost, msg);
  }
 
  render() {
    var MSG = HELP_MSG;
    
    if (isLoggedIn()) {
      // TODO: Maybe implement in the future - MSG += 'If you are from a department on campus and want to register to support your users through chat, please type register.';
    }
    
    return (
      <div>
        <ThemeProvider theme={theme}>
          <ChatBot 
            key={this.state.key}
            botAvatar={logo}
            floating={true}
            headerTitle='Bronco State Chat Feedback'
            steps={[
              {
                id: 'hello-world',
                message: MSG,
                trigger: 'userFeedback'
              },
              {
                id: 'userFeedback',
                user: true,
                trigger: 'feedback',
                validator: (value) => {
                  if (!value) {
                    return 'Feedback should not be empty';
                  }
                  
                  return true;
                },
              },
              {
                id: 'feedback',
                component: <SendFeedback userId={this.state.userId} feedback={this.handleNewUserMessage} register={this.handleNewRegisterMessage} />,
                asMessage: true,
                replace: false,
                waitAction: true,
                trigger: 'feedback-finish'
              },
              {
                id: 'feedback-token',
                component: <SendFeedback userId={this.state.userId} feedback={this.handleNewUserMessage} register={this.handleNewRegisterMessage} token={true} />,
                asMessage: true,
                replace: true,
                waitAction: true,
                trigger: 'feedback-finish'
              },
              {
                id: 'token',
                user: true,
                trigger: 'feedback-token',
                validator: (value) => {
                  if (!value) {
                    return 'Token should not be empty';
                  }
                  
                  return true;
                },
              },
              {
                id: 'feedback-finish',
                message: 'Thank you for your assistance! Let us know if you need anything else!',
                end: true
              },
              {
                id: 'error',
                message: 'Something went wrong. Please try again later',
                end: true
              }
            ]}
          />
        </ThemeProvider>
        <FeedbackWidget render={true} value={this.state.key} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    feedback: state.connect.connectFeedback.connectFeedback,
    feedbackHasErrored: state.connect.connectFeedback.connectFeedbackHasErrored,
    feedbackIsLoading: state.connect.connectFeedback.connectFeedbackIsLoading,
    register: state.connect.connectRegister.connectRegister,
    registerHasErrored: state.connect.connectRegister.connectRegisterHasErrored,
    registerIsLoading: state.connect.connectRegister.connectRegisterIsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFeedback: (host, msg) => dispatch(connectFeedbackFetchData(host, msg)),
    fetchRegister: (host, msg) => dispatch(connectRegisterFetchData(host, msg))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Feedback));
